import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  Divider,
  TextField,
  InputAdornment,
} from "@mui/material";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import RouteService from "src/service/route";
import {
  IconFileDownload,
  IconPlus,
  IconSearch,
  //  IconSearch
} from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";
// import moment from "moment";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Route Setup",
  },
];

const Route = () => {
  const navigate = useNavigate();

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [route, setRoute] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);
  //  for table sorting
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("device_name"); // Initial column to sort

  const fetch_route_data = async () => {
    try {
      const res = await RouteService.get_route_list({});

      setRoute(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteRoute = async (id) => {
    swal({
      title: "Delete Route",
      text: "Are you sure you want to delete this route?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await RouteService.deleteRoute({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetch_route_data();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  useEffect(() => {
    fetch_route_data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExport = () => {
    const headers = [
      "Sl. No",
      "Route Name",
      "Starting Point",
      "End Point",
      "Total Distance",
    ];

    const data = visibleData.map((man, index) => [
      index + 1,
      man.route_name,
      man.start_pt_name,
      man.end_pt_name,
      man.distance,
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "Route Details.xlsx";

    writeFile(wb, fileName);
  };

  // table column sorting start here
  const handleSort = (column) => {
    // Toggle sorting order if clicking on the same column
    if (sortColumn === column) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      // Set new column to sort
      setSortColumn(column);
      // Default sorting order for the new column
      setSortOrder("asc");
    }
  };

  const formatTimeDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0) {
      return `${hours} Hrs ${remainingMinutes} Min`;
    } else {
      return `${remainingMinutes} Min`;
    }
  };

  return (
    <PageContainer title="Route" description="this is Basic Table page">
      {/* breadcrumb */}
      <Breadcrumb title="Route" items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Route Setup
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            {sessionData.data.user_type === 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("/addnewroute");
                }}
              >
                <IconPlus width={20} />
              </Button>
            )}

            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder="search here"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>
        {/* </ParentCard> */}

        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell>
                    <Typography style={{ fontSize: "14px" }} variant="h6">
                      Sl. No
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("route_name")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Route Name
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "route_name" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("start_pt_name")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Starting Point
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "start_pt_name" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("end_pt_name")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      End Point
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "end_pt_name" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("distance")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Total Distance (Km)
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "distance" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("distance")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Total Duration (Hrs)
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "distance" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    {sessionData.data.user_type === 1 && (
                      <>
                        <Typography
                          style={{ fontSize: "15px", textAlign: "center" }}
                          variant="h6"
                        >
                          Action
                        </Typography>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {route.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  route
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((man, index) => (
                      <TableRow key={man.id}>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {index + 1}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {man.route_name}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {man.start_pt_name}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {man.end_pt_name}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {man.distance}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {formatTimeDuration(man?.time_duration) ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {sessionData.data.user_type === 1 && (
                            <>
                              <Link to={`/updatenewroute/${man.id}`}>
                                <ModeEditOutlinedIcon
                                  style={{
                                    color: "blue",
                                    fontSize: "18px",
                                    cursor: "pointer",
                                    marginLeft: "10px",
                                  }}
                                />
                              </Link>
                              <DeleteOutlinedIcon
                                style={{
                                  color: "red",
                                  fontSize: "18px",
                                  marginLeft: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => deleteRoute(man.id)}
                              />
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={route.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default Route;
